(function(){
    'use strict'

    angular.module('app.tiposAccionPersonal')
    .factory('TiposAccionPersonalService', TiposAccionPersonalService);

    TiposAccionPersonalService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function TiposAccionPersonalService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update: update,
            remove: remove
        };

        return api;

        function getAll(companiaId){

            var url = apiSettings.apiBaseUrl + 'api/tipos-accion-personal/' + companiaId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(companiaId, tipoAccionPersonalId){

            var url = apiSettings.apiBaseUrl + 'api/tipos-accion-personal/' + companiaId + '/' + tipoAccionPersonalId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(tipoAccionPersonal){

            if(!tipoAccionPersonal.companiaId){
                tipoAccionPersonal.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-accion-personal',  
                method: 'POST',  
                data: tipoAccionPersonal
            });  
            return response;
        };

        function update(tipoAccionPersonal){

            if(!tipoAccionPersonal.companiaId){
                tipoAccionPersonal.companiaId = UserInfoService.getCompaniaId();
            }

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-accion-personal',  
                method: 'PUT',  
                data: tipoAccionPersonal
            });  
            return response;
        };

        function remove(tipoAccionPersonal){

            if(!tipoAccionPersonal.companiaId){
                tipoAccionPersonal.companiaId = UserInfoService.getCompaniaId();
            }
            
            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/tipos-accion-personal',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: tipoAccionPersonal
            });  
            return response;
        };

    };

})();